export default function TagChip({ label }) {
  return <span className="tag-chip">{label}</span>;
}
